<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(updateUser)">
      <md-card style="max-height: 690px;">
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">Documents</h4>
            <p class="category">Student Documents</p>
          </div>
        </md-card-header>

        <md-card-content style="padding-bottom:0px">
          <div class="md-layout">
            <div class="md-layout-item">
              <ValidationProvider
                name="picture"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Profile Picture</label>
                  <md-file
                    v-model="picture"
                    name="picture"
                    @change="onPictureChange"
                  />

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <md-button
              class="md-just-icon md-primary md-round md-layout-item md-size-10 md-label-on-right"
              :href="picture"
              target="_blank"
            >
              <md-icon>cloud_download</md-icon>
              <md-tooltip md-direction="bottom">Download</md-tooltip>
            </md-button>
          </div>

          <div class="md-layout">
            <div class="md-layout-item">
              <ValidationProvider
                name="passport"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Passport</label>
                  <md-file
                    v-model="passport"
                    name="passport"
                    @change="onFileChange"
                  />

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <md-button
              class="md-just-icon md-primary md-round md-layout-item md-size-10 md-label-on-right"
              :href="passport"
              target="_blank"
            >
              <md-icon>cloud_download</md-icon>
              <md-tooltip md-direction="bottom">Download</md-tooltip>
            </md-button>
          </div>

          <div class="md-layout">
            <div class="md-layout-item">
              <ValidationProvider
                name="diploma"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Diploma</label>
                  <md-file
                    v-model="diploma"
                    name="diploma"
                    @change="onFileChange"
                  />

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <md-button
              class="md-just-icon md-primary md-round md-layout-item md-size-10 md-label-on-right"
              :href="diploma"
              target="_blank"
            >
              <md-icon>cloud_download</md-icon>
              <md-tooltip md-direction="bottom">Download</md-tooltip>
            </md-button>
          </div>

          <div class="md-layout">
            <div class="md-layout-item">
              <ValidationProvider
                name="transcript"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Transcript</label>
                  <md-file
                    v-model="transcript"
                    name="transcript"
                    @change="onFileChange"
                  />

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <md-button
              class="md-just-icon md-primary md-round md-layout-item md-size-10 md-label-on-right"
              :href="transcript"
              target="_blank"
            >
              <md-icon>cloud_download</md-icon>
              <md-tooltip md-direction="bottom">Download</md-tooltip>
            </md-button>
          </div>

          <div class="md-layout">
            <div class="md-layout-item">
              <ValidationProvider
                name="cv"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>CV</label>
                  <md-file v-model="cv" name="cv" @change="onFileChange" />

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <md-button
              class="md-just-icon md-primary md-round md-layout-item md-size-10 md-label-on-right"
              :href="cv"
              target="_blank"
            >
              <md-icon>cloud_download</md-icon>
              <md-tooltip md-direction="bottom">Download</md-tooltip>
            </md-button>
          </div>

          <div class="md-layout-item md-size-100">
            <h5 class="info-text"></h5>
          </div>
        </md-card-content>
      </md-card>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, confirmed, numeric } from "vee-validate/dist/rules";

extend("required", required);
extend("numeric", numeric);

export default {
  components: {
    SlideYDownTransition
  },
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      userID: null,
      picture: null,
      passport: null,
      diploma: null,
      transcript: null,
      cv: null,
      other_files: [],
      table_spinner: true
    };
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    onPictureChange(e) {
      var file = e.target.files[0] || e.dataTransfer.files[0];
      let fieldName = e.target.name;
      // Student user
      let role = 2;
      this.$store
        .upsertBasicUser("PATCH", this.userID, { picture: file }, role)
        .then(response => {
          this.$notify({
            message: "Upload Successful",
            icon: "add_alert",
            type: "success",
            verticalAlign: "top",
            timeout: 4000
          });
        })
        .catch(error => {
          var message = error.response.data;
          this.$notify({
            message: JSON.stringify(message),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top",
            timeout: 5000
          });
        });
      this.$notify({
        message: "Uploading...",
        icon: "add_alert",
        type: "info",
        verticalAlign: "top",
        timeout: 4000
      });
      // if (!files.length) return;
      // this.createImage(files[0]);
    },
    onFileChange(e) {
      var file = e.target.files[0] || e.dataTransfer.files[0];
      let fieldName = e.target.name;
      this.$store
        .addUserFile(this.userID, file, fieldName)
        .then(response => {
          this.$notify({
            message: "Upload Successful",
            icon: "add_alert",
            type: "success",
            verticalAlign: "top",
            timeout: 3000
          });
        })
        .catch(error => {
          var message = error.response.data;
          this.$notify({
            message: JSON.stringify(message),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top",
            timeout: 5000
          });
        });
      this.$notify({
        message: "Uploading...",
        icon: "add_alert",
        type: "info",
        verticalAlign: "top",
        timeout: 3000
      });
      // if (!files.length) return;
      // this.createImage(files[0]);
    }
  },
  mounted() {
    this.userID = this.$route.params.id;
  }
};
</script>
<style></style>
